export default {
    xml : {
        'PplInterv': {
            'SotrName':               'Employee',
            'SotrKey':                'Responsible for the document',
            'AlsoParticipated':       'Also participated',
            'Candidate':              'Related to person',
            'CandKey':                'Candidate key',
            'PersonalAppearance':     'Personal appearance',
            'PersonalQualities':      'Personal qualities',
            'ProfessionalMotivation': 'Professional motivation',
            'ProfessionalExperience': 'Professional experience, personal achievements',
            'IntDate':                'Date',
            'LanguageSkills':         'Foreign language skills',
            'DifFromCV':              'Mismatches between CV and actual gaps in career',
            'WantSalary':             'Salary, package and expectation',
            'JobSearchHistory':       'Job search history',
            'WherePresent':           'Where to present/not to present candidacy',
            'WhereEfficient':         'Jobs in which candidate can be efficient in the future',
            'DopInfo':                'Additional information',
            'DocumentLettersUpdate':  'characters are entered:'
        },
        'PplPhoneInterv': {
            'REKR':                  'Responsible for the document',
            'REKRKEY':               'Employee key',
            'CAND':                  'Related to person',
            'CANDKEY':               'Candidate key',
            'INTDATE':               'Date',
            'JobExperience':         'Job experience, current position and responsibilities',
            'ForeignLanguage':       'Foreign language skills',
            'DrivingLicense':        'Driving license, private car',
            'Education':             'Education, special skills',
            'PCSkills':              'PC skills',
            'WhatJobIsInterested':   'What job is interested',
            'JobSearchHistory':      'Job search history',
            'SalaryExpectations':    'Salary expectations, compensation package',
            'LocationRequirements':  'Location requirements',
            'AdditionalInformation': 'Additional information',
            'PersonalImpressions':   'Personal impressions',
            'ConverationOutcome':    'Conclusion on the results of the interview',
            'Motivation':            'Motivation of the candidate',
            'Experience':            'Professional experience and knowledge',
            'createdate':            'Create date',
            'sekrfio':               'Data entry secretary',
            'sekrdate':              'Date',
            'sekrworkname':          'Completed work',
        },
        'PplSomeForm': {
            'Text': 'Text'
        },
        'PplVerRek': {
            'Employee':                   'Employee',
            'Candidate':                  'Candidate',
            'POS':                        'Position',
            'REKOMFIO':                   'Referrer',
            'REKOMCOMP':                  'Current employment of the referrer',
            'REKOMDOLG':                  'Referrer position',
            'REKOMPHONE':                 'Referrer phone number/email',
            'HOWLONGKNOW':                'How long have known him/her?',
            'YOUDECIDEPRIM':              'Who took decision to hire him/her?',
            'YOUDECIDEPRIM_FORM':         '(if talking to manager) Who took decision to hire him/her?',
            'WHENWORK':                   'At what time and in which company(ies) did you work with him/her?',
            'VERREKDATE':                 'Date',
            'WASREKCHIEF':                'Please tell if you were his/her supervisor? Colleague? Subordinate?',
            'WHATTASK':                   'What tasks did (s)he accomplish? What work did (s)he perform?',
            'WHATFUNC':                   'What were his/her responsibilities during the time worked together?',
            'REKNAME':                    'What were your positions during the time you worked together?',
            'MARK':                       'How do you evaluate his/her results, what was done in terms of work on this position? How was the efficiency evaluated?',
            'ACHIEVE':                    'What could you highlight as his/her major achievements?',
            'DIF':                        'What tasks did/did not (s)he manage to accomplish?',
            'VKLAD':                      'What was his/her personal impact towards the result of the whole team?',
            'RESULT':                     'How would you assess his/her results in comparison with set objectives?',
            'CMPRESULT':                  'How would you assess his/her work results in comparison with other employees on similar positions?',
            'HOWWORK':                    'How do you evaluate his/her work attitude? (overtimes, discipline). Was (s)he a reliable employee?',
            'WHATOUTFAKTOR':              'What is his/her main stimulus in work?',
            'STIMUL':                     'What job-related situations were stressful for him/her? How did it look like? How did (s)he overcome that?',
            'WHYSTESS':                   'Were there any factors outside job affecting his/her results?',
            'STRONG':                     'What are his strengths in your opinion?',
            'STRONG_FORM':                'What are his strengths in your opinion? (and what else?)',
            'NOTSTRONG':                  'What qualities should (s)he improve to be more successful in work?',
            'WITHCHIEF':                  'What was his/her relations with team (with colleagues, subordinates, management)? Is (s)he a team player?',
            'WITHOUT':                    'What were the relations with clients, customers, suppliers?',
            'WHATCHIEF':                  'How could you describe him/her as a manager? How did (s)he build up relations with subordinates?',
            'WASCHIEF':                   'How many employees did (s)he supervise? Directly/indirectly? What kind of personal was that?',
            'WASSAMOST':                  'Did (s)he have to make own/unpopular decisions? Which ones? What were the consequences?',
            'WASTRUDO':                   'Did (s)he personally take decisions regarding hiring/firing of people? How readily did (s)he take responsibility for the team actions?',
            'WITHKOLLEGA':                'Were there difficulties, conflicts in work with colleagues, subordinates, management? What was their nature? Which side did (s)he take?',
            'WHYGO':                      'Why do you think (s)he was fired/left your company? Who took the decision regarding his/her dismissal?',
            'WANTHIMCOMMENT':             'Would you re-employ him/her? Why?',
            'WANTHIMCOMMENT_FORM':        '(for manager) Would you re-employ him/her? Why?',
            'ADDINFORM':                  'Could you add something else that I didn`t ask?',
            'WHYYOUREKOM':                'How capable do you think (s)he is of this work? What could help me to correctly evaluate his/her qualification and skills?',
            'WHATFUTURECHIEF':            'How should the future supervisor treat or deal with him/her to make them most effective?',
            'WHUWILLGO':                  'What is the reason why (s)he quit/wants to quit the company? What would be/was the reaction of management/employees on his departure?',
            'WANTHIMKOLLEGA':             'Would you like (are you ready) to work with him/her again? Why?',
            'WANTHIMKOLLEGA_FORM':        '(for colleague, subordinate) Would you like (are you ready) to work with him/her again? Why?',
            'ADDQUESTION':                'Own additional question or specific question from supervisor',
            'WHATREKOTN':                 'How well did you get along with him/her?',
            'HOWLONGSTART':               'How quickly did the person familiarize with the company and start being efficient as an employee?',
            'CLIENTFIO':                  'Line manager full name',
            'CLIENTFIO_FORM':             'Full name of the person requesting',
            'CLIENTCOMP':                 'Company',
            'generalInfo':                'General information',
            'collaborationPeriod':        'Collaboration period',
            'subordinationSystem':        'Subordination system «candidate / adviser»',
            'mainTasks':                  'The main tasks and functions of the candidate',
            'workResults':                'Results of work and achievements',
            'strengths':                  'Strengths',
            'peopleManagement':           'Managing people (for leadership positions)',
            'weakSides':                  'Weaknesses and areas for development',
            'peopleRelationships':        'Relations with people',
            'workAttitude':               'Attitude to work',
            'futurеLeader':               'The future leader',
            'leavingReasons':             'The reasons for dismissal/desire to consider',
            'desireAgainWork':            'Desire to work with the candidate again',
            'futureWorkCompliance':       'Compliance with future work',
            'candidateAdditionalinfo':    'Additional information about the candidate',
            'yourAdditionalQuestion':     '«Own» additional question or specific issue of the line manager',
            'documentResponsible':        'Responsible for the document',
            'recomFio':                   'Full Name',
        },
        'MrktCall': {
            'SOTRKEY':               'Employee key',
            'SOTRNAME':              'Employee',
            'PPLKEY':                'Client employee key',
            'PPLNAME':               'Client employee',
            'ORGNAME':               'Client company name',
            'ORGKEY':                'Client company key',
            'DATE':                  'Date',
            'PPLDOLG':               'Client employee position',
            'ABOUTSPEAK':            'Content of conversation',
            'SIGN':                  'Impression about other party and add. information',
            'RESULT':                'What agreements were made? (Results of contact)',
            'TYPE':                  'Marketing contact type',
            'TARGET':                'Marketing contact objective',
            'ADDANCORSOTR':          'Also participated employees',
            'ADDZAKSOTR':            'Also participated client employees',
            'ORGKATEGOR':            'Client category',
            'INFABOUT':              'Source of marketing information',
            'NEXTDATE':              'Next contact date',
            'TARGETDESCR':           'Next contact objective',
            'NEXCTCNT_OBJECTIVESTR': 'Next contact objective (briefly)',
            'NEXTCNTTYPEST':         'Next contact type',
            'CNTOBJECTIVESTR':       'Contact objective (briefly)',
            'CNTRESULTSTR':          'Result of contact (briefly)',
            'NEXTCNT_SOTRKEY':       'Next contact employee key',
            'NEXTCNT_SOTRNAME':      'Employee (next contact)'
        },
        'PplZakInterv': {
            'INTDATE':  'Date',
            'CANDNAME': 'Candidate',
            'ZAKNAME':  'Contact person',
            'POSNAME':  'Position',
            'ZAKINFO':  'Information from contact person',
            'CONTINFO':  'Information (%(label)s)',
            'CLNTINFO': 'Information from client',
            'CANDINFO': 'Info from candidate'
        },
        'IntRecrRequest': {
            'request_date':             'Request date',
            'posname':                  'Position',
            'prjtype':                  'Project type',
            'whomarket':                'Active marketing',
            'zakazdepartkey':           'Department',
            'otvkey':                   'Responsible',
            'orgname':                  'Company',
            'numeqpos':                 'Quantity',
            'town':                     'City',
            'is_budget':                'Presence in the Budget',
            'posreason':                'Reason of Opening',
            'replace_ppl':              'Replaced employee',
            'deadline':                 'Close before',
            'salary':                   'Salary min',
            'salaryvaluta':             'Currency',
            'salarybudgeted':           'Salary max',
            'split':                    'Compensations and Benefits',
            'gonorar_fix':              'Fee',
            'grossnet':                 'Before / After Taxation',
            'probation':                'Probation period',
            'typeofexpirience':         'Yrs of Exp.',
            'agefrom':                  'Age from',
            'ageto':                    'Age to',
            'sex':                      'Sex',
            'workplace':                'Workplace',
            'chartofwork':              'Work schedule',
            'typeofemployment':         'Employment type',
            'typeofeducation':          'Education',
            'education':                'Education’s comment',
            'experiencefunctions':      'Experience requirements',
            'responsibilities':         'Responsibilities',
            'personality':              'Personal qualities',
            'language':                 'Foreign languages',
            'ppl_zakaz':                'Client',
            'town_code':                'City (code)',
            'budget_code':              'Presence in the Budget (code)',
            'posreason_code':           'Reason of Opening (code)',
            'replace_ppl_code':         'Replaced employee (code)',
            'department_code':          'Department (code)',
            'department':               'Department',
            'salaryvaluta_code':        'Currency (code)',
            'gonorar_type_valuta_code': 'Fee currency (code)',
            'grossnet_code':            'Before / After Taxation (code)',
            'typeofexpirience_code':    'Yrs of Exp. (code)',
            'sex_code':                 'Sex (code)',
            'workplace_code':           'Workplace (code)',
            'chartofwork_code':         'Work schedule (code)',
            'typeofemployment_code':    'Employment type (code)',
            'typeofeducation_code':     'Education (code)',
            'ppl_zakaz_code':           'HR-manager (code)',
            'datefrom':                 'Date from',
            'mainprim':                 'Additional Information',
            'price':                    'Price',
            'finprim':                  'Additional conditions',
            'kadryorgkey':              'Legal entity of customer',
            'kadryanckey':              'Legal entity of executive',
            'valuta':                   'Currency',
            'otvcfo':                   'Responsible for CFO',
            'classifstr':               'Classifier',
            'PosAlterName':             'Alternative name',
            'name':                     'Language',
            'level':                    'Proficiency',
            'LICENSE':                  'Drivers license',
            'BUSINESS_TRIPS_STR':       'Business trips',
            'BUSINESS_TRIPS_PERCENT':   'Business trips (%)'
        },
        'PrjSomeForm': {
            'Company': 'Related to',
            'Text': 'Text of document',
            'createdate': 'Create date',
            'sekrfio': 'Data entry secretary',
            'sekrdate': 'Date',
            'sekrworkname': 'Completed work',
        },
        'OrgSomeForm': {
            'Company': 'Related to',
            'Text': 'Text of document',
            'createdate': 'Create date',
            'sekrfio': 'Data entry secretary',
            'sekrdate': 'Date',
            'sekrworkname': 'Completed work',
        },
        'SomeFormMain': {
            'company': 'Company',
            'project': 'Project',
            'Text': 'Text',
        },
        'PplAnketa' : {
            'createdate': 'Date of create',
            'full-name': 'Full name',
            'sex': 'Sex',
            'citizenship': 'Citizenship',
            'contact-phone': 'Contact phone',
            'email': 'E-mail',
            'year_graduation': 'Year of ending',
            'education-level': 'The level of education',
            'family-status': 'Family status',
            'education-form': 'Education form',
            'education-type': 'Education type',
            'rus-lang-level': 'Level of Russian language',
            'eng-lang-level': 'Level of English',
            'military': 'Military duty',
            'children': 'Children',
            'bad-habits': 'Bad habits',
            'conviction': 'Conviction',
            'pc-level': 'PC skill',
            'personal-car': 'Personal car',
            'use-personal-car': 'Willingness to use a personal car',
            'spec-tech': 'Special equipment management',
            'work-permissions': 'Tolerances to work',
            'medical-book': 'Medical book',
            'int-passport': 'Passport',
            'time-sheet': 'Work schedule',
            'work-type': 'Type of employment',
            'time-to-work': 'Time to work',
            'ready-to-move': 'Relocation',
            'businesstrip': 'Business trip',
            'work-experience': 'Work experience',
            'feedback': 'Feedback',
            'desired-position': 'Desired position',
            'wait-money': 'Salary expectation',
            'home-phone': 'Home phone',
            'mob-phone': 'Mobile phone',
            'birthPlace': 'Place of Birth',
            'birth-date': 'Date of Birth',
            'institute': 'The name of the institution',
            'speciality': 'Specialty',
            'computerSkills': 'Computer skills',
            'NISSAN_HEAD_FULLNAME': 'Full name of the head',
            'NISSAN_HEAD_POSITION': 'Position manager',
            'NISSAN_HEAD_PHONE': 'Executive phone',
            'NISSAN_HEAD_EMAIL': 'Email manager',
            'workFunction': 'Main responsibilities',
            'begin-date': 'Start of work (month/year)',
            'end-date': 'End of work (month/year)',
            'organization': 'Organization',
            'position': 'Position',
            'competenceName': 'Competence name',
            'competenceValue': 'Evaluation',
            'nissanInstitute': 'University',
            'nissanEducationDate': 'Year / month of graduation',
            'nissanSpeciality': 'Specialty',
            'nissanEdicationLevel': 'Qualification',
            'title': {
                'form': 'Form',
                'residenceAddress': 'Residence address',
                'phones': 'Phones',
                'contacts': 'Contacts',
                'education': 'Higher and specialized secondary education',
                'landingData': 'Data from the landing page',
                'workExperience': 'Experience',
                'nissanEducation': 'Education, courses',
                'head': 'Head',
                'competence': 'Competences',
            }

        },
        'OrgMrktCallData': {
            'SOTRNAME':             'Employee',
            'PPLNAME':              'Client employee',
            'ORGNAME':              'Client company name',
            'DATE':                 'Date',
            'PPLDOLG':              'Client employee position',
            'ABOUTSPEAK':           'Content of conversation',
            'SIGN':                 'Impression about other party and add. information',
            'RESULT':               'Result of contact',
            'TYPE':                 'Marketing contact type',
            'TARGET':               'Marketing contact objective',
            'ADDANCORSOTR':         'Also participated employees',
            'ADDZAKSOTR':           'Also participated client employees',
            'ORGKATEGOR':           'Client category',
            'INFABOUT':             'Source of marketing information',
            'NEXTDATE':             'Next contact date',
            'NEXTCNTTYPEST':        'Next contact type',
            'NEXTCNT_SOTRNAME':     'Employee (next contact)',
            'TARGETDESCR':          'Comment',
            'title': {
                'marketingContact': 'Marketing contact',
                'client': 'Client',
                'selfParticipants': 'Participants of the meeting/conversation from the company',
                'clientParticipants': 'Participants meeting / conversation from the client',
            }
        },
        test: {
            name: 'Name',
            score: 'Score',
            id: 'ID',
            scales: {
                'PCTL': 'Percentile',
                'GRADE': 'Grade',
                'T': 'T-score',
            },
        },
        resume: {
            'about': 'About',
            'email': 'Email',
            'education': 'Education',
            'addinfo': 'Additional information',
            'address': 'Address',
            'birthday': 'Birthday',
            'businesstrip': 'Business trip',
            'citizen': 'Citizenship',
            'experience': 'Experience',
            'first_name': 'First name',
            'im':'Messenger',
            'language': 'Languages',
            'last_name': 'Last name',
            'lastupdate': 'Last update',
            'metro': 'Underground',
            'middle_name': 'Surname',
            'own_url': 'Own site',
            'phone': 'Phone',
            'relocation': 'Relocation',
            'sex': 'Sex',
            'skill': 'Skills',
            'wait_status': 'Wait status',
            'wait_money': 'alary expectations'
        },
        title: {
            personImpression: 'Impression of a person',
            profExperience: 'Professional experience',
            salary: 'Salary expectations',
            profMotivation: 'Professional motivation',
            jobSearchHistory: 'Job Search History',
            interviewConsolution: 'Conclusions from interview results',
            alsoParticipated: 'Also participated',
            additionalComments: 'Additional comments',
            cardEdited: 'Card was edited',
            managerInfo: 'Information from contact person',
            candidateInfo: 'Information from candidate',
            interview: 'Interview',
            recomendation: 'Verification of recommendations',
            forLineManager: 'For line manager',
            recommender: 'Recommender',
            coopWorkPeriod: 'Collaboration period',
            subordinationSystem: '«Candidate / Referee» submission system',
            mainTasks: 'The main tasks and functions of the candidate',
            workResults: 'Result of work and achievements',
            strength: 'Strengths',
            managment: 'Management of people',
            weakSides: 'Weaknesses and areas for development',
            peopleRelations: 'Relations with people',
            workAttitude: 'Attitude to work',
            futureLeader: 'The future leader',
            dismissalReasons: 'The reasons for dismissal / desire to consider',
            workDesire: 'Desire to work with the candidate again',
            complianceFutureWork: 'Compliance with future work',
            additionalInformation: 'Additional information about the candidate',
            yourQuestion: 'Its an additional question or a specific question of the line manager',
            marketing: 'Marketing contact',
            conversationСontent: 'Conversation content',
            interlocutorImpression: 'Impression about the interlocutor and additional information',
            nextContact: 'Next contact',
        }
    }
};
